<template>
  <v-data-table light v-if="trophyList"
                :headers="headers"
                :items="trophyList"
                noDataText="Keine Erfolge vorhanden."
                :pagination.sync="pagination"
                class="elevation-1 inlineBtn">
    <template slot="items" slot-scope="props">
      <td class="grey">
        <v-badge bottom right overlap color="black" class="trophy-badge"
                 :class="parseInt(props.item.place) != 1 && parseInt(props.item.place) != 2 && parseInt(props.item.place) != 3 ? 'medal' : ''">
          <span slot="badge" light>{{ props.item.place }}</span>
          <span :class="placeTrophyIcon(parseInt(props.item.place)).class">{{placeTrophyIcon(parseInt(props.item.place)).trophy}}</span>
        </v-badge>
      </td>
      <td class="">
        <span class="black--text">{{ props.item.competition_name }}</span>
      </td>
      <td class="">
        <span> {{ props.item.competition_category }}</span>
      </td>
      <td class="">
        <span class="black--text">   {{ props.item.date }}</span>
      </td>
    </template>
  </v-data-table>
</template>
<script>

  export default {
    name: 'athlete-trophy-table',
    props: {
      trophyList: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        headers: [
          {text: 'Place ', value: 'place'},
          {text: 'Competition', align: 'left', value: 'competition'},
          {text: 'Category', align: 'left', value: 'category'},
          {text: 'Date', align: 'left', value: 'date'},
          {text: '', align: 'left', value: 'action'}
        ],
        pagination: {
          sortBy: 'date',
          descending: true
        },
      }
    },
    methods: {
      placeTrophyIcon(place) {
        switch (place) {
          case 1:
            return {class: 'first-place', trophy: '🏆'};
          case 2:
            return {class: 'second-place', trophy: '🏆'};
          case 3:
            return {class: 'third-place', trophy: '🏆'};
          default:
            return {class: 'px-2', trophy: '🏅'};
        }
      }
    }
  }
</script>
<style lang="scss">
  .trophy-badge {
    &:first-child{
      font-size: 30px;
    }
    > span {

      &.first-place {
        color: gold;
      }
      &.second-place {
        color: silver;
      }
      &.third-place {
        color: darkgoldenrod;
        text-shadow: #ffffff 1px 1px 1px;
      }
      color: goldenrod;
      text-shadow: #ffffff 0px 0px 1px;
    }
    span.v-badge__badge {
      height: 15px;
      width: 15px;
      font-size: 10px;
      bottom: 0 !important;
      right: 0;
      background: rgba(38, 135, 113, 0.2) !important;
      box-shadow: black 1px 1px 1px;
      color: white;
    }
  }

  .small-font {
    input, .input-group__selections__comma {
      font-size: 12px;
    }
  }
</style>
